__turbopack_context__.v({
  "badge": "FieldCardContent-module-scss-module__HYE5qG__badge",
  "badgeStatic": "FieldCardContent-module-scss-module__HYE5qG__badgeStatic",
  "declaring": "FieldCardContent-module-scss-module__HYE5qG__declaring",
  "exampleContent": "FieldCardContent-module-scss-module__HYE5qG__exampleContent",
  "exampleSection": "FieldCardContent-module-scss-module__HYE5qG__exampleSection",
  "exampleTitle": "FieldCardContent-module-scss-module__HYE5qG__exampleTitle",
  "fieldCard": "FieldCardContent-module-scss-module__HYE5qG__fieldCard",
  "label": "FieldCardContent-module-scss-module__HYE5qG__label",
  "name": "FieldCardContent-module-scss-module__HYE5qG__name",
  "row": "FieldCardContent-module-scss-module__HYE5qG__row",
  "type": "FieldCardContent-module-scss-module__HYE5qG__type",
});
